import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { AdminSidebar } from "@/layouts/AdminSidebar";
import { Logo } from "@/components/brand/Logo";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useI18n } from "@/i18n/I18nProvider";

export default function AdminLayout() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-[100dvh] bg-[#F8FAFC]">
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-[272px] lg:block" data-testid="admin-sidebar">
        <AdminSidebar />
      </aside>
      <header className="sticky top-0 z-20 flex h-16 items-center justify-between gap-3 border-b border-[#E5E7EB] bg-white/95 px-4 backdrop-blur-md lg:hidden">
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label={t("common.menu")}
          data-testid="admin-mobile-menu-button"
          className="flex h-11 w-11 items-center justify-center rounded-lg text-[#000B45] transition-colors hover:bg-[#F8FAFC]"
        >
          <Menu className="h-6 w-6" />
        </button>
        <Logo size="sm" testId="admin-header-logo" />
        <LanguageToggle testIdPrefix="header-lang" />
      </header>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[85vw] max-w-[300px] border-0 p-0 [&>button]:text-white" data-testid="admin-mobile-drawer">
          <SheetTitle className="sr-only">{t("common.menu")}</SheetTitle>
          <AdminSidebar onNavigate={() => setOpen(false)} idPrefix="mnav" />
        </SheetContent>
      </Sheet>
      <main className="lg:pl-[272px]">
        <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 sm:py-8 lg:px-10 lg:py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
